/* DigitalPower - DP - Видео отзив (v1.9.5): телефон с вертикални клипове.
   Пуска се само при клик (със звук), един клип наглас, чипове за смяна, лента за прогреса, бутон за звука,
   пауза при излизане от екрана или смяна на таба. Без зависимости. */
(function () {
  var roots = document.querySelectorAll('[data-vt]');
  if (!roots.length) return;
  var all = [];

  function video(clip) { return clip.querySelector('[data-vt-video]'); }

  roots.forEach(function (root) {
    var clips = [].slice.call(root.querySelectorAll('[data-vt-clip]'));
    var chips = [].slice.call(root.querySelectorAll('[data-vt-chip]'));
    var mute = root.querySelector('[data-vt-mute]');
    if (!clips.length) return;
    var cur = root.querySelector('[data-vt-clip].is-on') || clips[0];

    function setMuteUi(v) { if (mute) mute.setAttribute('aria-pressed', v.muted ? 'true' : 'false'); }

    function start(clip) {
      var v = video(clip);
      if (v.preload === 'none') v.preload = 'auto';
      v.muted = false;
      setMuteUi(v);
      var p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // ако браузърът откаже звук без жест: пускаме без звук, бутонът го връща
          v.muted = true;
          setMuteUi(v);
          v.play().catch(function () {});
        });
      }
    }

    clips.forEach(function (clip) {
      var v = video(clip);
      var bar = clip.querySelector('[data-vt-bar]');
      var play = clip.querySelector('[data-vt-play]');
      all.push(v);
      if (play) play.addEventListener('click', function () { start(clip); });
      v.addEventListener('click', function () { if (v.paused) { start(clip); } else { v.pause(); } });
      v.addEventListener('play', function () {
        clip.classList.add('is-playing', 'is-started');
        root.classList.add('is-playing');
        if (mute) mute.hidden = false;
        all.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      });
      v.addEventListener('pause', function () {
        clip.classList.remove('is-playing');
        root.classList.remove('is-playing');
      });
      v.addEventListener('ended', function () {
        clip.classList.remove('is-playing', 'is-started');
        root.classList.remove('is-playing');
        if (mute) mute.hidden = true;
        if (bar) bar.style.width = '0%';
        try { v.currentTime = 0; } catch (e) {}
      });
      v.addEventListener('timeupdate', function () {
        if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100).toFixed(2) + '%';
      });
    });

    function show(i) {
      var next = clips[i - 1];
      if (!next || next === cur) return;
      var was = !video(cur).paused;
      video(cur).pause();
      cur.classList.remove('is-on');
      next.classList.add('is-on');
      chips.forEach(function (ch) {
        var on = ch.getAttribute('data-vt-chip') === String(i);
        ch.classList.toggle('is-on', on);
        ch.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (mute) mute.hidden = !next.classList.contains('is-started') && !was;
      cur = next;
      if (was) start(next);
    }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function () { show(parseInt(ch.getAttribute('data-vt-chip'), 10)); });
    });

    if (mute) {
      mute.addEventListener('click', function () {
        var v = video(cur);
        v.muted = !v.muted;
        setMuteUi(v);
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) { var v = video(cur); if (!v.paused) v.pause(); }
        });
      }, { threshold: 0.1 }).observe(root);
    }

    root.__dpVt = { show: show, start: function (i) { start(clips[(i || 1) - 1]); }, current: function () { return clips.indexOf(cur) + 1; } };
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) all.forEach(function (v) { if (!v.paused) v.pause(); });
  });
})();
